import React from 'react';

/**
 * StepBadge
 * ------------------------------------------------------------------
 * Small pill used to show progress context at the top of a step,
 * e.g. "Step 1 of 4" (tone="info") or "Review" (tone="accent").
 *
 * @param {'info'|'accent'|'success'} tone
 */
const CustomStepBadge = ({ children, tone = 'info', className = '' }) => {
  return <span className={`amok-step-badge amok-step-badge--${tone} ${className}`}>{children}</span>;
};

export default CustomStepBadge;